import type { PostPurchaseSetupIssue } from "@intelligems/ig-types";

/**
 * What a store still needs before a post-purchase upsell can work, in the
 * order the merchant has to fix it, or null once it's ready. Refreshing
 * Shopify permissions fixes the first two; support turns on cart metafields.
 */
export const getPostPurchaseSetupIssue = (options: {
  hasWriteOrders: boolean;
  hasStorefrontToken: boolean;
  hasCartMetafields: boolean;
}): PostPurchaseSetupIssue | null => {
  if (!options.hasWriteOrders) {
    return "writeOrders";
  }
  if (!options.hasStorefrontToken) {
    return "storefrontToken";
  }
  if (!options.hasCartMetafields) {
    return "cartMetafields";
  }
  return null;
};

export const PostPurchaseSetupStartMessages: Record<
  PostPurchaseSetupIssue,
  string
> = {
  writeOrders:
    "Refresh your Shopify permissions to start this post-purchase upsell",
  storefrontToken:
    "Refresh your Shopify permissions to start this post-purchase upsell",
  cartMetafields:
    "Contact support to enable cart metafields before starting this post-purchase upsell",
};
